import { useEffect } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { SharedLayout } from "./SharedLayout/index";
import "./index.css";
import { LoginLayout } from "./LoginLayout";
import { Helmet } from "react-helmet";
import favicon from "./assets/netmonk-logo.ico";
import { Analytics } from "./Analytics";
import { Alarms } from "./Alarms";
import { Settings } from "./Settings";
import { CheckHiAccount } from "./PageMiddleware/CheckHiAccount";
import { CheckPrimeAccount } from "./PageMiddleware/CheckPrimeAccount";
import { DeviceViewAll } from "./Analytics/DeviceViewAll";
import { AlarmsViewAll } from "./Alarms/AlarmsViewAll";
import { DetailComponent } from "./Analytics/DeviceDetails/DeviceDetailAnalysis/DetailComponent";
import { DetailQOS } from "./Analytics/DeviceDetails/DeviceDetailAnalysis/DetailQOS";
import { DetailTraffic } from "./Analytics/DeviceDetails/DeviceDetailAnalysis/DetailTraffic";
import { CapacityForecast } from "./Analytics/DeviceDetails/DeviceDetailAnalysis/CapacityForecast";
import { AlarmDetails } from "./Alarms/AlarmDetails";
import { initGA } from "./GoogleAnalytics";
import { PageTracker } from "./PageMiddleware/PageTracker";
import { DetailAnalysis } from "./Analytics/DeviceDetails";
import { AboutUs } from "./Settings/AboutUs";
import { Faq } from "./Settings/Faq";
import "./i18n";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

const App = () => {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} />
        </Helmet>
        <Routes>
          <Route element={<PageTracker />}>
            <Route path="/" element={<Navigate to="/analytics" replace />} />
            <Route path="/login" element={<LoginLayout />} />
            <Route element={<SharedLayout />}>
              <Route path="/analytics" element={<Analytics />} />
              <Route
                path="/analytics/device-detail-analysis/:type/:id"
                element={<DetailAnalysis />}
              />
              <Route
                path="/analytics/device-detail-analysis/:type/:id/component-detail/:resource/:componentId"
                element={<DetailComponent />}
              />
              <Route
                path="/analytics/device-detail-analysis/:type/:id/qos-detail/:type"
                element={<DetailQOS />}
              />
              <Route
                path="/analytics/device-detail-analysis/:type/:id/traffic-detail/:interfaceId"
                element={<DetailTraffic />}
              />
              <Route
                path="/analytics/device-detail-analysis/:type/:id/capacity-forecast/:resource/:forecastId"
                element={<CapacityForecast />}
              />
              <Route element={<CheckPrimeAccount />}>
                <Route
                  path="/analytics/device-clear"
                  element={<DeviceViewAll deviceStatus={"device-clear"} />}
                />
                <Route
                  path="/analytics/device-down"
                  element={<DeviceViewAll deviceStatus={"device-down"} />}
                />
                <Route
                  path="/analytics/device-attention"
                  element={<DeviceViewAll deviceStatus={"device-attention"} />}
                />
              </Route>
              <Route element={<CheckHiAccount />}>
                <Route
                  path="/analytics/internet-online"
                  element={<DeviceViewAll deviceStatus={"internet-online"} />}
                />
                <Route
                  path="/analytics/internet-offline"
                  element={<DeviceViewAll deviceStatus={"internet-offline"} />}
                />
                <Route
                  path="/analytics/internet-suspend"
                  element={<DeviceViewAll deviceStatus={"internet-suspend"} />}
                />
                <Route
                  path="/analytics/internet-technical-issue"
                  element={
                    <DeviceViewAll deviceStatus={"internet-technical-issue"} />
                  }
                />
              </Route>
              <Route path="/alarms" element={<Alarms />} />
              <Route
                path="/alarms/read"
                element={<AlarmsViewAll alarmStatus={"read"} />}
              />
              <Route
                path="/alarms/unread"
                element={<AlarmsViewAll alarmStatus={"unread"} />}
              />
              <Route path="/alarms/:id" element={<AlarmDetails />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/settings/faq" element={<Faq />} />
              <Route path="/settings/about-us" element={<AboutUs />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </I18nextProvider>

  );
};

ReactDOM.render(<App />, document.getElementById("root"));
